import Axios from "axios";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import storeList from "../../common/storeList";
import NotData from "../../components/NotData";
import { Toast } from '../../common/message';
import { elapsedTime } from "../../common/howDate";
import UserPointExp from "../../common/UserPointExp";

const SaleLog = ({ sessionData }) => {

  // 시간 불러오는 부분
  let toDate = new dayjs().format('YYYY-MM-DD');
  let toTime = new dayjs().format('YYYY-MM-DD HH:mm:ss')

  const minusDate = (number)=>{
    const now = new dayjs().subtract(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const plusDate = (number)=>{
    const now = new dayjs().add(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const toDay = {
    date: toDate,
    time: toTime,
    minusDate,
    plusDate
  }
  
  const basicStore = window.sessionStorage.getItem("basicStore");
  const basicDate = toDay.date;

  // 로컬스토리지에 이미 변환된 스토어가 있으면 그걸 먼저 가져옴
  const [store, setStore] = useState(basicStore);

  // 로컬스토리지에 이미 변환된 데이트가 있으면 그걸 먼저 가져옴
  const [toDates, setToDates] = useState(basicDate);

  const [search, setSearch] = useState("");

  const [books, setBooks] = useState([]);
  const columns =  ["No", "메모", "브랜드", "분류", "제품이름", "가격", "수량", "할인", "금액합계", "시간"];
  const columnsALL =  ["No", "메모", "매장", "브랜드", "분류", "제품이름", "가격", "수량", "할인", "금액합계", "시간"];
  
  const [cancelState, setCancelState] = useState(false);
  const [saleDate, setSaleDate] = useState("");  

  const [saleType, setSaleType] = useState('');

  const [saleState, setSaleState] = useState('');

  const [itemIno, setItemIno] = useState(0);
  const [itemNo, setItemNo] = useState(0);
  const [itemName, setItemName] = useState("");
  const [itemCount, setItemCount] = useState(0);
  const [itemCard, setItemCard] = useState(false);
  const [itemCash, setItemCash] = useState(false);
  const [itemTransfer, setItemTransfer] = useState(false);
  const [itemMemo, setItemMemo] = useState("");

  const [storeTotalPrice, setStoreTotalPrice] = useState(0);

  const [cardTotal, setCardTotal] = useState(0);
  const [cardTotalPrice, setCardTotalPrice] = useState(0);

  const [cashTotal, setCashTotal] = useState(0);
  const [cashTotalPrice, setCashTotalPrice] = useState(0);

  const [transferTotal, setTransferTotal] = useState(0);
  const [transferTotalPrice, setTransferTotalPrice] = useState(0);

  // 숫자 천자리 콤마
  function NumberConvert(num) {
    var num_parts = num.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return num_parts.join(".");
  }

  const [itemIdx, setItemIdx] = useState(0);

  // 단일 매장 데이터 불러오기
  const storeData = async ()=>{
    await Axios.get(`/api/salelog/store_data`, { params: { store: store, date: toDates } })
    .then((res) => {
      if (res.data.length) {
        setCardTotal(Number(res.data[0].VALUE));
        setCardTotalPrice(Number(res.data[1].VALUE));
        setCashTotal(Number(res.data[2].VALUE));
        setCashTotalPrice(Number(res.data[3].VALUE));
        setTransferTotal(Number(res.data[4].VALUE));
        setTransferTotalPrice(Number(res.data[5].VALUE));
        setStoreTotalPrice(Number(res.data[6].VALUE));
      } else {
        setCardTotal(0);
        setCardTotalPrice(0);
        setCashTotal(0);
        setCashTotalPrice(0);
        setTransferTotal(0);
        setTransferTotalPrice(0);
        setStoreTotalPrice(0);
      }
    });
  }
  
  // 수정된 값으로 교체
  const copyStateUpdate = ()=>{
    setBooks(()=>{
      const copy = [...books]
      copy[itemIdx].state = '취소';
      storeData();
      return copy;
    });
  }

  // 내역 불러오기
  const TableItemGet = async () => {
    await Axios.get(`/api/salelog/store`, {
      params: { store: store, date: toDates }
    }).then((res) => {
      if (res.data.length) {
        setBooks(res.data);
      } else {
        setBooks([]);
      }
    });
  };

  const [allCardCounts, setAllCardCounts] = useState(0);
  const [allCashCounts, setAllCashCounts] = useState(0);
  const [allTransferCounts, setAllTransferCounts] = useState(0);

  const [allCardTotals, setAllCardTotals] = useState(0);
  const [allCashTotals, setAllCashTotals] = useState(0);
  const [allTransferTotals, setAllTransferTotals] = useState(0);

  const [allTotalPrices, setAllTotalPrices] = useState(0);

  // 전체 매장
  const allStoreData = async () => {
    await Axios.get(`/api/salelog/storeall_data`, { params: { date: toDates } })
    .then((res) => {
      if (res.data.length) {        
        setAllCardCounts(Number(res.data[0].VALUE)+ Number(res.data[1].VALUE)+ Number(res.data[2].VALUE)+ Number(res.data[3].VALUE));
        setAllCardTotals(Number(res.data[4].VALUE)+ Number(res.data[5].VALUE)+ Number(res.data[6].VALUE)+ Number(res.data[7].VALUE));

        setAllCashCounts(Number(res.data[8].VALUE)+ Number(res.data[9].VALUE)+ Number(res.data[10].VALUE) + Number(res.data[11].VALUE));
        setAllCashTotals(Number(res.data[12].VALUE) + Number(res.data[13].VALUE) + Number(res.data[14].VALUE) + Number(res.data[15].VALUE));

        setAllTransferCounts(Number(res.data[16].VALUE) + Number(res.data[17].VALUE) + Number(res.data[18].VALUE) + Number(res.data[19].VALUE));
        setAllTransferTotals(Number(res.data[20].VALUE) + Number(res.data[21].VALUE) + Number(res.data[22].VALUE) + Number(res.data[23].VALUE));

        setAllTotalPrices(Number(res.data[24].VALUE) + Number(res.data[25].VALUE) + Number(res.data[26].VALUE) + Number(res.data[27].VALUE));
      } else {
        setAllCardCounts(0);
        setAllCardTotals(0);
        setAllCashCounts(0);
        setAllCashTotals(0)
        setAllTransferCounts(0);
        setAllTransferTotals(0);
        setAllTotalPrices(0);
      }
    });
  };

  // 유즈이펙트
  useEffect(()=>{
    document.title = '판매내역';

    if(window.sessionStorage.getItem('basicPermission') >= 4 && store === '전체'){
      allStoreData();
    } else if(store !== '전체') {
      storeData();
    }

    TableItemGet()    
    reset();
  }, [store, toDates]);

  // 분류 탭 부분
  const handleStore = (e) => {
    setSearch("");
    setStore(e.target.value);
  };

  // 날짜 탭 부분
  const handleDate = (e) => {
    setSearch("");
    setToDates(e.target.value);
  };

  // 검색 버튼 클릭
  const searchBtn = (e) => {
    e.preventDefault();
    if (search === "") return alert("검색어를 입력하세요.");
    if (store === "전체") return alert("전체 매장 검색은 불가능합니다.");
    const fecthAllBooks = async () => {
      await Axios.get(`/api/salelog/search`, {
        params: { store: store, date: toDate, text: search },
      }).then((res) => {
        if (res.data.length) {
          setBooks(res.data);
        } else {
          setBooks([]);
        }
      });
    };
    fecthAllBooks();
    document.getElementById("searchInput").value = "";
  };

  // 판매 취소 버튼
  const ItemSaleCancle = async (e) => {
    e.preventDefault();
    if (itemIno === 0 && itemNo === 0) return alert("취소할 제품을 선택해 주세요.");
    if (store === "전체") return alert("매장 조회 선택이 '전체'일 땐 판매 취소를 할 수 없습니다.");
    if (store !== basicStore) return alert(`${basicStore} 계정입니다, 타 매장 취소 처리는 불가능합니다.`);
    if (cancelState) return alert('이미 취소된 제품입니다.');

    // 처리된지 1주일이 지났을 경우 취소 불가능.
    const first = saleDate.slice(0, 10).replace(/-/g, '');
    const next = toDay.date.replace(/-/g, '');
    if(next - first > 7) return alert('7일이 지난 정보는 취소가 불가능합니다');

    if (window.confirm(`${itemName}을 취소 처리하시겠습니까?`))
      // 아이템 삭제 처리
      await Axios.put(`/api/salelog/salecancle`, {
        store: store, itemIno: itemIno, itemNo: itemNo,
        itemCount: itemCount, saleCancleDate: toDay.time,
      })
      .then((res) => {
        Toast.fire({ icon: "success", text: `${itemName} 취소 처리 완료` });
        copyStateUpdate();

        // 포인트 및 기여도 차감
        UserPointExp('제품판매', `${itemName} 판매 취소`, 1, 1, '차감');
        
      });
    setSelectedRow(-1);
    setItemIno(0);
  };

  const reset = ()=>{
  setItemIno(0);
  setItemNo(0);
  setItemName("");
  setItemCard(false);
  setItemCash(false);
  setItemTransfer(false);
  setItemMemo("");
  setSaleDate("");
  setSearch('');
  setItemCount(0);

  setSelectedRow(-1);
  }

  // 셀렉트 테스트
  const [selectedRow, setSelectedRow] = useState(-1);

  return (
    <div className="p-3 text-sm grid grid-cols-1 md:flex gap-3 md:h-[calc(100vh-4rem)] md:gap-1">

      {/* 메인 */}
      <div className="flex flex-col justify-between gap-1 md:w-3/4 w-full">
        
        {/* 데이터 리스트 */}
        <div className="overflow-y-auto border-[1px] border-gray-500 md:h-full h-[50vh]">
          <table id='testTable' className='w-full max-h-[78vh]'>
            <thead className="bg-[#1E1E1E]/90 whitespace-nowrap text-center sticky top-0 z-10">
              <tr className="border-b-[1px] border-gray-500">
                {
                  store === '전체'
                  ?
                  columnsALL.map((column) => (
                    <th className="p-3" key={column}>
                      {column}
                    </th>
                  ))
                  :
                  columns.map((column) => (
                    <th className="p-3" key={column}>
                      {column}
                    </th>
                  ))
                }                
              </tr>
            </thead>
            <tbody className="text-center">
              {books.length ? (
                books.map((book, idx) => (
                  <tr
                    className={`
                      duration-150 whitespace-nowrap active:scale-[0.98] active:opacity-80
                      ${book.state === '취소' ? 'decoration-red-500/80' : 'decoration-yellow-600'}
                      ${selectedRow === idx ? 'bg-[#1E1E1E] decoration-[3px] font-bold underline' : 'even:bg-[#3E3E3E]' && book.state === '취소' ? 'bg-red-600/60' : 'even:bg-[#3E3E3E]'}
                    `}
                    key={idx}
                    onClick={() => {
                      book.state === '취소' ? setCancelState(true) : setCancelState(false)
                      setSaleState(book.state);
                      setSelectedRow(idx);
                      setItemIdx(idx);
                      setItemNo(book.no);
                      setItemIno(book.i_no);
                      setItemName(book.name);
                      setItemCard(book.card);
                      setItemCash(book.cash);
                      setItemTransfer(book.transfer);
                      setItemMemo(book.memo);
                      setSaleDate(book.date);
                      setItemCount(book.count);

                      setSaleType(()=>{
                        if(book.service){
                          return '서비스'
                        } else if(book.testing){
                          return '시연용'
                        } else {
                          return '판매'
                        }
                      });

                      window.sessionStorage.setItem('select_copy', book.name);
                    }}
                  >
                    {/* {book.cover && <img src={book.cover} alt="book `alt`.." />} */}
                    <td className="p-2.5">{idx + 1}</td>
                    <td className={`p-2.5 border-x-[1px] border-gray-500 ${book.memo && 'animate-pulse'}`}>
                      {book.memo ? "📝" : "-"}
                    </td>
                    {
                      store === '전체' &&                      
                      <td className={`p-2.5 border-x-[1px] border-gray-500 ${basicStore === book.store && 'text-yellow-400'}`}>
                        {!book.store ? '-' : book.store}
                      </td>
                    }
                    <td className="p-2.5 border-x-[1px] border-gray-500">{book.brand}</td>
                    <td className="p-2.5 border-x-[1px] border-gray-500">{book.type}</td>
                    <td className="p-2.5 border-x-[1px] border-gray-500">{
                      (book.service === 1 && `〈서비스〉 ${book.name}`) ||
                      (book.testing === 1 && `〈시연용〉 ${book.name}`) || book.name
                    }</td>
                    <td className="p-2.5 border-x-[1px] border-gray-500">
                      {NumberConvert(book.price)} 원
                    </td>
                    <td className="p-2.5 border-x-[1px] border-gray-500">{book.count} 개</td>
                    <td className={`p-2.5 border-x-[1px] border-gray-500`}>
                      {
                        !book.discount ? "-" : `🏷️ ${NumberConvert(book.discount)} 원`
                      }
                      {/* 😍💕💵💰🔖🏷️📜💀☠️👻💝🌞*/}
                    </td>
                    <td className="p-2.5 border-x-[1px] border-gray-500">
                      {NumberConvert(book.total)} 원
                    </td>
                    <td className={`p-2.5 ${elapsedTime(book.date) === '방금 전' && 'animate-pulse'}`}>{elapsedTime(book.date)}</td>
                  </tr>
                ))
              ) : (
                <tr className="relative">
                  <td className={`absolute w-full top-[15vh] left-auto`}>
                    <NotData />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* 하단 판매금액 */}        
        <div className={`flex flex-col w-full overflow-x-auto overflow-y-hidden md:h-52 justify-center border-[1px] border-gray-500
          ${window.sessionStorage.getItem('basicPermission') < 4 && store !== basicStore ? 'hidden' : 'inline'}
          ${window.sessionStorage.getItem('basicPermission') >= 4 && 'inline'}
        `}>
        {/* <div className={`${store !== basicStore ? 'hidden' : 'inline'} flex flex-col w-full overflow-x-auto overflow-y-hidden md:h-52 justify-center border-[1px] border-gray-500`}> */}
          <div className="bg-[#0067BD] h-10 py-2 text-center">
            <p className="text-left pl-3 whitespace-nowrap">
              ※ 판매내역 카드 / 현금 / 계좌이체 현황
            </p>
          </div>

          <div className="flex justify-center h-full items-center p-3 bg-[#3E3E3E]">
            <div className="flex gap-5 sm:justify-center overflow-x-auto w-full overflow-y-hidden whitespace-nowrap">
              <div className="bg-[#2E2E2E] shadow-md shadow-gray-[#1E1E1E] duration-150 hover:scale-110 flex gap-3 p-5 flex-col justify-center items-center rounded-md">
                <p className="text-center text-gray-300 tracking-widest">카드 결제 {`( ${store === '전체' ? allCardCounts : cardTotal} 건 )`}</p>
                <input
                  disabled
                  className="font-bold bg-[#2E2E2E] tracking-widest md:w-40 w-32 text-center"
                  type="text"
                  value={`${store === '전체' ? NumberConvert(allCardTotals) : NumberConvert(cardTotalPrice)} 원`}
                />
              </div>
              <div className="bg-[#2E2E2E] shadow-md shadow-gray-[#1E1E1E] duration-150 hover:scale-110 flex gap-3 p-5 flex-col justify-center items-center rounded-md">
                <p className="text-center text-gray-300 tracking-widest">현금 결제 {`( ${store === '전체' ? allCashCounts : cashTotal} 건 )`}</p>
                <input
                  disabled
                  className="font-bold bg-[#2E2E2E] tracking-widest md:w-40 w-32 text-center"
                  type="text"
                  value={`${store === '전체' ? NumberConvert(allCashTotals) : NumberConvert(cashTotalPrice)} 원`}
                />
              </div>
              <div className="bg-[#2E2E2E] shadow-md shadow-gray-[#1E1E1E] duration-150 hover:scale-110 flex gap-3 p-5 flex-col justify-center items-center rounded-md">
                <p className="text-center text-gray-300 tracking-widest">이체 결제 {`( ${store === '전체' ? allTransferCounts : transferTotal} 건 )`}</p>
                <input
                  disabled
                  className="font-bold bg-[#2E2E2E] tracking-widest md:w-40 w-32 text-center"
                  type="text"
                  value={`${store === '전체' ? NumberConvert(allTransferTotals) : NumberConvert(transferTotalPrice)} 원`}
                />
              </div>
            </div>
          </div>
        </div>

      </div>

      {/* 사이드 */}
      <div className="md:w-1/4 w-full md:overflow-y-auto bg-[#424242] border-[1px] border-gray-500">
        <div className="bg-[#0067BD] py-2 text-center">
          <p className="text-left pl-3">※ 판매, 서비스, 시연용 내역</p>
        </div>
        <div className="p-3 flex flex-col gap-2">
          {/* 제품검색 */}
          {/* <div>
            <form className="flex gap-2" autoComplete="off">
              <input
                id="searchInput"
                className="bg-[#2E2E2E] h-12 w-full p-2 rounded-md text-center outline-none border-[1px] border-gray-400"
                type="search"
                placeholder="검색어"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }} 
                onDoubleClick={()=>setSearch(window.sessionStorage.getItem('select_copy'))
              }
              />
              <input
                className="bg-blue-600 px-3 py-2 h-12 rounded-sm w-[30%] cursor-pointer"
                type="submit"
                value="검색"
                onClick={searchBtn}
              />
            </form>
          </div> */}

          {/* 매장 및 날짜 조회 */}
          <div className="grid gap-2">
            <div className="w-full">
              <p>매장 조회</p>
              <select
                id="storeInput"
                className="w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md cursor-pointer outline-none border-[1px] border-gray-400"
                value={store}
                onChange={handleStore}
              >
                {storeList.storeAll.map((item) => (
                  <option value={item} key={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <div className="w-full">
              <p>날짜 조회</p>
              <input
                id="dateInput"
                type="date"
                className="w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400"
                value={toDates}
                onChange={handleDate}
              />
            </div>
          </div>

          {/* 언더라인 */}
          <div className="border-b-[1px] border-gray-400 py-1"></div>

          {/* 제품이름 */}
          <div className="">
            <p>제품 이름</p>
            <input
              className={`bg-[#2E2E2E] decoration-red-500 duration-150 mt-2 rounded-t-md w-full h-20 text-center font-bold border-b-[1px] hover:border-blue-500 border-gray-400 ${saleState === '취소' && 'line-through decoration-4 hover:no-underline'}`}
              placeholder="〈 제품을 선택하세요 〉"
              disabled
              type="text"
              value={itemName}
            />
          </div>

          {/* 결제방식 */}
          <div className="">
            <div className="flex justify-between gap-3">
              <p className="">결제 상태</p>
              <button
                className="text-yellow-400"
                onClick={() => {
                  alert("제품 판매시 손님이 결제하신 방식입니다.");
                }}
              >
                도움말
              </button>
            </div>

            {/* 결제 현황 */}
            <div className="flex justify-center items-center gap-3 p-3 bg-[#2E2E2E] mt-2 rounded-md py-4">
              <ul className="grid w-full gap-2 grid-cols-3 text-center">
                <li>
                  <input
                    readOnly
                    value="card"
                    checked={itemCard ? true : false}
                    type="checkbox"
                    className="hidden peer"
                    required=""
                  />
                  <label className="grid duration-150 items-center justify-center text-center w-full cursor-not-allowed px-5 py-2 rounded-lg hover:text-gray-300 border-gray-700 border-2 peer-checked:border-blue-500 peer-checked:text-gray-200 text-gray-400 bg-gray-800 hover:bg-gray-700">
                    <div className="w-full whitespace-nowrap">카드</div>
                  </label>
                </li>
                <li>
                  <input
                    readOnly
                    value="cash"
                    checked={itemCash ? true : false}
                    type="checkbox"
                    className="hidden peer"
                  />
                  <label className="grid duration-150 items-center justify-center text-center w-full cursor-not-allowed px-5 py-2 rounded-lg hover:text-gray-300 border-gray-700 border-2 peer-checked:border-blue-500 peer-checked:text-gray-200 text-gray-400 bg-gray-800 hover:bg-gray-700">
                    <div className="w-full whitespace-nowrap">현금</div>
                  </label>
                </li>
                <li>
                  <input
                    readOnly
                    value="transfer"
                    checked={itemTransfer ? true : false}
                    type="checkbox"
                    className="hidden peer"
                  />
                  <label className="grid duration-150 items-center justify-center text-center w-full cursor-not-allowed px-5 py-2 rounded-lg hover:text-gray-300 border-gray-700 border-2 peer-checked:border-blue-500 peer-checked:text-gray-200 text-gray-400 bg-gray-800 hover:bg-gray-700">
                    <div className="w-full whitespace-nowrap">이체</div>
                  </label>
                </li>
              </ul>
            </div>
          </div>

          {/* 참고사항 */}
          <div className={`${itemMemo ? 'visible' : 'hidden'} flex flex-col gap-2`}>
            <div className="flex justify-between gap-3">
              <p className="">참고사항</p>
              <button
                className="text-yellow-400"
                onClick={() => alert("텍스트박스 우측 하단을 드래그시 창을 늘리거나 축소 할 수 있습니다.")}
              >
                펼치기
              </button>
            </div>
            <div className="flex flex-col justify-center items-center">
              <textarea
                className={`${itemMemo && 'bg-blue-500/80'} w-full h-22 outline-none bg-[#2E2E2E] rounded-md ml-5 mr-5 p-3 text-center`}
                placeholder="메모가 없습니다"
                disabled
                type="text"
                value={itemMemo}
              />
            </div>
          </div>

          {/* 언더라인 */}
          <div className="border-b-[1px] border-gray-400 py-1"></div>

          {/* 판매 날짜 */}
          <div id="priceText" className="flex flex-col justify-center gap-3">
            <p>판매 날짜</p>
            <input
              className="bg-[#2E2E2E] h-12 rounded-md text-center"
              disabled
              type="text"
              placeholder="〈 제품을 선택하세요 〉"
              value={saleDate}
            />
          </div>

          {/* 판매 취소 */}
          <div className={`flex flex-col gap-2 pt-2 ${store !== basicStore && 'hidden'}`}>
            <button
              className={`bg-[#2E2E2E] h-12 w-[100%] rounded-md text-center ${saleState !== '취소' ? 'border-[1px] border-yellow-300' : 'border-[0px] cursor-not-allowed'}`}
              onClick={ItemSaleCancle}
            >
              {`              
              ${saleState === '취소' ? '이미 취소된 상태입니다' : `${saleType === '' ? '어떤걸 취소 하시겠습니까?' : `${saleType} 취소`}` }
              `}
            </button>
          </div>

          {/* 언더라인 */}
          <div className="border-b-[1px] border-gray-400 py-1"></div>

          {/* 당일 판매금액 */}
          {
            <div id="priceText" className={`
            flex flex-col justify-center gap-3
            ${window.sessionStorage.getItem('basicPermission') < 4 && store !== basicStore && 'hidden'}
            ${window.sessionStorage.getItem('basicPermission') >= 4 && 'inline'}
            `}>
              <div className="flex justify-between gap-3">
                <p className="">당일 판매 금액</p>
                <button
                  className="text-yellow-400"
                  onClick={() => alert("당일 판매금액")}
                >
                  도움말
                </button>
              </div>
              <input
                className="font-bold bg-[#2E2E2E] h-14 rounded-md text-center border-[1px] border-gray-300 tracking-wider text-base"
                disabled
                type="text"
                value={`${store === '전체' ? NumberConvert(allTotalPrices) : NumberConvert(storeTotalPrice)} 원`}
                />
                {/* ${window.sessionStorage.getItem('basicPermission') < 4 ? NumberConvert(storeTotalPrice) : NumberConvert(allTotalPrices)} 원 */}
            </div>
          }

          <div className="flex text-xs mt-3 gap-3 bg-[#2E2E2E] rounded-md p-5">
            <div className="min-w-[35px] h-[35px] bg-green-600 rounded-md text-center">
              <span className="text-2xl font-bold">!</span>
            </div>
            <div className="text-center">
              <p>
                ※ 마감 하실때{" "}
                <span className="text-green-300">포스기 판매 금액</span>과
                맞는지 <u className="text-red-400">꼭</u> 확인해 주세요.
              </p>
              <p className="text-center">
                <span className="text-gray-400">
                  포스기와 프로그램의 판매 금액이 맞지 않을 경우 재고가 정확하지
                  않을 수 있습니다.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default SaleLog;
